<div class="rental-list">
  <div class="page-header">
    <h1 class="page-title">Прокат</h1>
    <button mat-mini-fab color="primary" routerLink="/rentals/new" aria-label="Добавить">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text" [ngModel]="searchQuery" (ngModelChange)="onSearchInput($event)"
           placeholder="Поиск по телефону или названию авто" aria-label="Поиск прокатов">
    <button *ngIf="searchQuery" matSuffix mat-icon-button type="button"
            aria-label="Очистить" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="onTabChange($event)"
                 animationDuration="0ms" class="status-tabs">
    <mat-tab label="Все">
      <div class="tab-content">
        <ng-container *ngTemplateOutlet="tabBody; context: { $implicit: tabs[0], tabIndex: 0 }"></ng-container>
      </div>
    </mat-tab>
    <mat-tab label="В прокате">
      <div class="tab-content">
        <ng-container *ngTemplateOutlet="tabBody; context: { $implicit: tabs[1], tabIndex: 1 }"></ng-container>
      </div>
    </mat-tab>
    <mat-tab label="Возвращённые">
      <div class="tab-content">
        <ng-container *ngTemplateOutlet="tabBody; context: { $implicit: tabs[2], tabIndex: 2 }"></ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #tabBody let-state let-tabIndex="tabIndex">
  <div *ngIf="state.loading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!state.loading && state.rentals.length > 0" class="rentals-list">
    <app-rental-card *ngFor="let r of state.rentals" [rental]="r"
                     [showHandoverLabel]="getShowHandoverLabel(tabIndex)"></app-rental-card>
  </div>
  <div *ngIf="!state.loading && state.rentals.length === 0" class="empty-state">
    <mat-icon>event_busy</mat-icon>
    <ng-container *ngIf="searchQuery; else noResults">
      <p>Ничего не найдено по запросу «{{ searchQuery }}»</p>
    </ng-container>
    <ng-template #noResults>
      <p>Нет прокатов</p>
    </ng-template>
  </div>
  <app-pagination *ngIf="!state.loading && state.totalItems > 0"
    [page]="state.page"
    [totalPages]="state.totalPages"
    [pageSize]="state.pageSize"
    [totalItems]="state.totalItems"
    (pageChange)="onPageChange($event, tabIndex)">
  </app-pagination>
</ng-template>
